import { render, staticRenderFns } from "./UcContractServiceFeeCard.yaml?vue&type=template&id=313925b8&component"
import script from "./UcContractServiceFeeCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractServiceFeeCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports